import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from 'angular-crumbs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { HeaderOneComponent } from './header-one/header-one.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { FooterComponent } from './footer/footer.component';
import { BrandsComponent } from './brands/brands.component';
import { TranslocoRootModule } from 'src/app/transloco-root.module';



@NgModule({
  declarations: [HeaderOneComponent, BreadcrumbComponent, FooterComponent, BrandsComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    BreadcrumbModule,
    SlickCarouselModule,
    TranslocoRootModule
  ],
  exports: [HeaderOneComponent, BreadcrumbComponent, FooterComponent, BrandsComponent]
})
export class SharedModule { }
